import React, { memo, useCallback, useRef, useState, useEffect } from "react";
import { Accordion, Button } from "react-bootstrap";
import Moment from 'react-moment';
import { NumericFormat } from 'react-number-format';
import { Link, useNavigate } from "react-router-dom";
import { BadgeStatus } from "../../Utils/Common";
import ModalDeleteCreateItem from './ModalDeleteCreateItem';
import UpdateItem from './UpdateItem';

const CardOfferItem = ({ item, onCallback }) => {

    const [modalUpdateItem, setModalUpdateItem] = useState(false);

    const [modalDeleteCreateItem, setModalDeleteCreateItem] = useState(false);

    const menuRight = useRef(null);

    const navigate = useNavigate();

    useEffect(() => {
        console.log(item);
    }, []);

    const onCallbackOnUpdateItem = useCallback((e) => {
        onCallback(e);
    }, []);

    const onCallbackDeleteItem = useCallback((e) => {
        onCallback(e);
    }, []);
    return (
        <>
            <div className="border rounded-2 mt-4">
                <div className="d-flex justify-content-between p-3">
                    <div>
                        <span className="fs-13">
                            <span>{item.inspectorName ? item.inspectorName : "-"}</span> <br />
                            {item.inspectionStatus != 'pending' &&
                                <span className="fs-13">Dikerjakan pada <Moment format="ddd, DD/MM/YYYY - HH:mm A">{item.inspection_date}</Moment></span>
                            }
                        </span>
                    </div>
                    <div className="text-muted">
                        <BadgeStatus status={item.inspectionStatus} />
                    </div>
                </div>
                <Accordion className="border-0" flush>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <div className="text-muted">
                                <strong className="fs-13">MOBIL</strong><br />
                                <span>{`${item.brandName}-${item.type}`}</span>
                            </div>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="text-muted mb-2">
                                <strong className="fs-13">TAHUN / ODOMETER</strong><br /><span>{item.builtYear}</span>
                                <NumericFormat
                                    value={item.odometer}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={' / '}
                                    renderText={(value, props) => <span {...props}>{value} KM</span>} />
                            </div>
                            <div className="text-muted mb-2">
                                <strong className="fs-13">NO POLISI</strong><br /><span>{item.policeNumber}</span>
                            </div>
                            <div className="text-muted mb-2">
                                <strong className="fs-13">PAJAK</strong><br /><span>{item.tax}</span>
                            </div>
                            <div className="text-muted mb-2">
                                <strong className="fs-13">WARNA</strong><br /><span>{item.color}</span>
                            </div>
                            <div className="text-muted mb-2">
                                <strong className="fs-13">TRANSMISSION</strong><br /><span>{item.transmission}</span>
                            </div>
                            <div className="text-muted mb-2">
                                <strong className="fs-13">BUKU SERVIS</strong><br /><span>{item.serviceRecords}</span>
                            </div>
                            <div className="text-muted mb-2">
                                <strong className="fs-13">BUKU MANUAL</strong><br /><span>{item.manualBook}</span>
                            </div>
                            <div className="text-muted mb-2">
                                <strong className="fs-13">LOKASI</strong><br /><span>{item.location}</span>
                            </div>
                            <div className="text-muted mb-2">
                                <strong className="fs-13">INSPEKTOR</strong>
                                <div className="d-flex justify-content-between border-bottom pb-3 mb-2">
                                    <div>
                                        <span>{item.inspectorName ? item.inspectorName : "-"}</span> <br />
                                        {item.inspectionStatus != 'pending' &&
                                            <span className="fs-13">Dikerkajan pada <Moment format="ddd, DD/MM/YYYY - HH:mm A">{item.inspection_date}</Moment></span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <div className="text-muted mb-2 p-3 pt-2">
                    <div className="row mb-3">
                        <div className="col d-grid gap-2">
                            <Button variant="outline-primary" onClick={(e) => setModalUpdateItem(true)}>Edit</Button>
                        </div>
                        <div className="col d-grid gap-2">
                            <Button variant="outline-danger" onClick={(e) => setModalDeleteCreateItem(true)}>Hapus</Button>
                        </div>
                        <UpdateItem onCallback={onCallbackOnUpdateItem} row={item} show={modalUpdateItem} close={(e) => setModalUpdateItem(false)} />
                        <ModalDeleteCreateItem onCallback={onCallbackDeleteItem} row={item} show={modalDeleteCreateItem} close={(e) => setModalDeleteCreateItem(false)} />
                    </div>
                    <div className="d-grid gap-2 mb-3">
                        {item?.id > 108 ?
                            <Link to={`/inspector/detil/${item.id}`} className="btn btn-outline-success">Lihat Hasil Inspeksi</Link> :
                            <Link to={`/inspeksi/detil/${item.id}`} className="btn btn-outline-success">Lihat Hasil Inspeksi</Link>
                        }

                    </div>
                    <div className="d-grid gap-2">
                        {item?.id > 108 ?
                            <Link to={`/inspector/${item.id}`} className="btn btn-outline-secondary">Form Inspeksi</Link> :
                            <Link to={`/inspeksi/${item.id}`} className="btn btn-outline-secondary">Form Inspeksi</Link>
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default memo(CardOfferItem);
